import React from 'react';
import './PropertyPanel.css';

export default function PropertyPanel({ showDate, setShowDate, showAuthor, setShowAuthor, showCount, setShowCount, showAvatar, setShowAvatar, customBgType, setCustomBgType, customBgColor, setCustomBgColor, customBgGradient, setCustomBgGradient, cardWidth, setCardWidth, contentBgOpacity, setContentBgOpacity, fontFamily, setFontFamily, fontOptions = [], textColor, setTextColor, textScale, setTextScale }) {
  return (
    <div className="property-panel">
      <div className="property-title">显示/隐藏元素</div>
      <div className="property-toggle-grid">
        <label className="property-item">
          <input type="checkbox" checked={showDate} onChange={e => setShowDate(e.target.checked)} /> 日期
        </label>
        <label className="property-item">
          <input type="checkbox" checked={showAuthor} onChange={e => setShowAuthor(e.target.checked)} /> 作者
        </label>
        <label className="property-item">
          <input type="checkbox" checked={showCount} onChange={e => setShowCount(e.target.checked)} /> 字数
        </label>
        <label className="property-item">
          <input type="checkbox" checked={showAvatar} onChange={e => setShowAvatar(e.target.checked)} /> 头像
        </label>
      </div>

      <div className="property-title" style={{marginTop: 24}}>自定义背景</div>
      <div className="property-bgtype-group">
        <label><input type="radio" name="bgtype" value="template" checked={customBgType==='template'} onChange={()=>setCustomBgType('template')} /> 模板</label>
        <label><input type="radio" name="bgtype" value="color" checked={customBgType==='color'} onChange={()=>setCustomBgType('color')} /> 纯色</label>
        <label><input type="radio" name="bgtype" value="gradient" checked={customBgType==='gradient'} onChange={()=>setCustomBgType('gradient')} /> 渐变</label>
        <label><input type="radio" name="bgtype" value="image" checked={customBgType==='image'} onChange={()=>setCustomBgType('image')} /> 背景图片</label>
      </div>
      {customBgType==='color' && (
        <div className="property-item">
          <input type="color" value={customBgColor} onChange={e=>setCustomBgColor(e.target.value)} />
          <span style={{marginLeft:8}}>{customBgColor}</span>
        </div>
      )}
      {customBgType==='gradient' && (
        <div className="property-gradient-group">
          <div className="property-item">
            <span>起色</span>
            <input type="color" value={customBgGradient.from} onChange={e=>setCustomBgGradient({...customBgGradient, from: e.target.value})} />
            <span style={{marginLeft:8}}>{customBgGradient.from}</span>
          </div>
          <div className="property-item">
            <span>止色</span>
            <input type="color" value={customBgGradient.to} onChange={e=>setCustomBgGradient({...customBgGradient, to: e.target.value})} />
            <span style={{marginLeft:8}}>{customBgGradient.to}</span>
          </div>
          <div className="property-item">
            <span>角度</span>
            <input type="number" min="0" max="360" value={customBgGradient.angle} onChange={e=>setCustomBgGradient({...customBgGradient, angle: Number(e.target.value)})} style={{width:60,marginLeft:8}} />°
          </div>
        </div>
      )}

      <div className="property-title" style={{marginTop: 24}}>卡片宽度</div>
      <div className="property-opacity-group">
        <input
          type="range"
          min={260}
          max={900}
          step={1}
          value={cardWidth}
          onChange={e => setCardWidth(Number(e.target.value))}
          style={{ width: 160 }}
        />
        <input
          type="number"
          min={260}
          max={900}
          step={1}
          value={cardWidth}
          onChange={e => setCardWidth(Number(e.target.value))}
          style={{ width: 60, marginLeft: 8, background: '#222', color: '#fff', border: '1px solid #444', borderRadius: 4, textAlign: 'center' }}
        /> px
      </div>

      <div className="property-title" style={{marginTop: 24}}>内容框背景</div>
      <div className="property-opacity-group">
        <input
          type="range"
          min={0}
          max={100}
          step={1}
          value={contentBgOpacity}
          onChange={e => setContentBgOpacity(Number(e.target.value))}
          style={{ width: 160 }}
        />
        <input
          type="number"
          min={0}
          max={100}
          step={1}
          value={contentBgOpacity}
          onChange={e => setContentBgOpacity(Number(e.target.value))}
          style={{ width: 60, marginLeft: 8, background: '#222', color: '#fff', border: '1px solid #444', borderRadius: 4, textAlign: 'center' }}
        /> %
      </div>

      <div className="property-title" style={{marginTop: 24}}>字体</div>
      <div className="property-item">
        <select
          className="property-select"
          value={fontFamily}
          onChange={e => setFontFamily(e.target.value)}
        >
          {fontOptions.map((option) => (
            <option key={option.value || option.label} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="property-title" style={{marginTop: 24}}>字体大小</div>
      <div className="property-fontsize">
        <span className="property-fontsize-label">字体大小 x {Number(textScale || 1).toFixed(1)}</span>
        <div className="property-fontsize-actions">
          <button
            type="button"
            className="property-fontsize-btn"
            onClick={() => setTextScale(Math.max(0.8, Number((textScale - 0.1).toFixed(1))))}
          >
            −
          </button>
          <button
            type="button"
            className="property-fontsize-btn"
            onClick={() => setTextScale(Math.min(2.4, Number((textScale + 0.1).toFixed(1))))}
          >
            +
          </button>
        </div>
      </div>
      <div className="property-title" style={{marginTop: 24}}>文本颜色</div>
      <div className="property-item">
        <input
          className="property-color"
          type="color"
          value={textColor}
          onChange={e => setTextColor(e.target.value)}
        />
        <input
          className="property-color-code"
          type="text"
          value={textColor}
          onChange={e => setTextColor(e.target.value)}
        />
      </div>
    </div>
  );
} 
